<template>
  <a-form-item
    v-if="data"
    :label="data.fieldname"
    class="select-tree"
    :class="data.fieldkey.replace('.', '_')"
  >
    <a-tree-select
      :value="value"
      :tree-data="treedata"
      :placeholder="placeholder"
      allow-clear
      show-search
      :multiple="multiple"
      :search-value="searchValue"
      :disabled="data.disabled"
      tree-default-expand-all
      tree-node-filter-prop="title"
      @change="onChange"
      @search="onSearch"
    />
  </a-form-item>
</template>

<script>
// import SelectTree from './../formItem/SelectTree'
import _ from 'lodash'
import { isParent } from '@/lib/utils'

export default {
  // extends: SelectTree,
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    placeholder: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: true
    },
    getData: {
      type: Function,
      default: () => { }
    }
  },
  data () {
    return {
      value: [],

      treedata: [],
      treedataObj: {
        children: {}
      },
      searchValue: ''
    }
  },
  computed: {
    fieldconfig () {
      const { fieldconfig = {} } = this.data
      return fieldconfig
    }
  },
  watch: {
    data: {
      handler (val) {
        this.init()
      },
      deep: true,
      immediate: true
    }
  },

  async created () {
    if (!this.data) return

    let _this = this
    const { data = {} } = this
    let { fieldkey, options = [] } = data

    if (!options.length) {
      options = await this.loadData()
    }

    for (let item of options) {
      item.pId = '0'
      item.pName = ''
    }
    this.setOptions(options)

    this.setObjTreedata(this.treedataObj.children, this.treedata)

    function documentHandler (e) {
      const className = fieldkey.replace('.', '_')
      const $el = document.querySelector('.' + className)

      if (!$el) return
      const flag1 = isParent(e.target, $el.querySelector('.ant-select-dropdown'))
      const flag2 = isParent(e.target, $el.querySelector('.ant-select'))

      if (!flag1 && !flag2) {
        _this.searchValue = ''
      }
    }
    document.addEventListener('click', documentHandler)
  },

  mounted () {
    this.$bus.$on('initSelectTreeFieldvalue', () => {
      this.init()
    })
  },
  beforeDestroy () {
    this.$bus.$off('initSelectTreeFieldvalue')
  },

  methods: {
    init () {
      if (!this.data) return

      // console.log('device', this.data)

      const { data = {} } = this
      let { fieldvalue = [] } = data
      this.data.fieldvalue = this.data.fieldvalue || {}
      if (this.$toType(fieldvalue) === 'array') {
        this.value = fieldvalue
      } else if (this.$toType(fieldvalue) === 'object') {
        this.value = Object.keys(fieldvalue)
      }

      // console.log('device', this.value)
    },
    async loadData () {
      const { fieldkey = '' } = this.data || {}

      const data = await this.getData({ fieldkey }) || {}

      return data
    },
    setOptions (options) {
      for (let item of options) {
        item.title = item.name
        // item.value = item.pId + '-' + item.id
        item.value = item.id
        item.key = item.pId + '-' + item.id

        if (item.children || item.child) {
          item.children = item.children || item.child || []
          for (let child of item.children) {
            child.pId = item.pId + '-' + item.id
            child.pName = item.pName + '/' + item.name
          }
          this.setOptions(item.children)
        }
      }
      this.treedata = options
    },
    onChange (value, label, extra) {
      // console.log(value, label, extra)
      this.value = value
      this.data.fieldvalue = _.zipObject(value, label)
      this.$emit('change', this.data.fieldvalue)
    },
    onSearch (value) {
      this.searchValue = value
    },
    onSelect () {
      // console.log(...arguments)
    },
    setObjTreedata (obj, options) {
      for (let item of options) {
        obj[item.id] = {}
        obj[item.id].name = item.name
        if (item.children) {
          obj[item.id].children = {}
          this.setObjTreedata(obj[item.id].children, item.children)
        }
      }
    }
  }
}
</script>

<style>
</style>
